import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "text-f3 md:text-f3 font-semibold pt-[2rem]" }, "Mitglieder", -1)
const _hoisted_2 = { class: "text-f5 md:text-f4" }
const _hoisted_3 = { class: "flex flex-wrap mt-[3rem] text-f5 text-orange-p" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 0,
  class: "pb-[2.5rem]"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", { class: "text-f3 font-medium mt-[4.5rem] mb-[3rem] w-full border-b-4 border-orange-p" }, " Vorstand ", -1)
const _hoisted_7 = { class: "w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-[2rem] mb-[2rem] md:mb-[1rem]" }
const _hoisted_8 = { class: "flex flex-col h-[40%] px-[1rem] py-[2rem] text-f5" }
const _hoisted_9 = { class: "text-f4 font-medium mb-[0.8rem]" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "flex flex-col flex-grow justify-end" }
const _hoisted_12 = { class: "text-f3 font-medium mt-[4.5rem] mb-[3rem] w-full border-b-4 border-orange-p" }
const _hoisted_13 = { class: "w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-[1rem]" }
const _hoisted_14 = { class: "flex flex-col h-[40%] px-[1rem] py-[2rem] text-f5" }
const _hoisted_15 = { class: "text-f4 font-medium mb-[0.8rem]" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "flex flex-col flex-grow justify-end" }

import { computed, ref } from "vue";

interface Member {
  id: number;
  vorname: string;
  nachname: string;
  instrument: string;
  image: {
    url: string;
    focalPoint: { x: number; y: number } | null;
  };
  aemtli: any[];
  since: string;
  vorstand: any | null;
}

interface InstrumentCategory {
  id: number;
  title: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MemberFilter',
  props: {
    members: {},
    instrumentCategories: {}
  },
  setup(__props: any) {

const props = __props;

const selectedCategory = ref<string | null>(null);
const vorstandOnly = ref<boolean>(false);

const groupedMembers = computed(() => {
  const groups = props.instrumentCategories.map((category) => ({
    instrument: category.title,
    members: props.members
    .filter((member) => member.instrument === category.title)
    .sort((a, b) => a.nachname.localeCompare(b.nachname)),
  }));
  return groups;
});

const filteredMembers = computed(() => {
  let filtered = groupedMembers.value;
  if (selectedCategory.value) {
    filtered = filtered.filter(
      (group) => group.instrument === selectedCategory.value
    );
  }
  if (vorstandOnly.value) {
    filtered = filtered
      .map((category) => ({
        ...category,
        members: category.members.filter((member) => member.vorstand),
      }))
      .filter((category) => category.members.length > 0);
  }
  return filtered;
});

const vorstandMembers = computed(() => {
  return props.members
  .filter((member) => member.vorstand)
  .sort((a, b) => a.nachname.localeCompare(b.nachname));
});

const toggleVorstandOn = () => {
  vorstandOnly.value = true;
};

const selectCategory = (category: string | null) => {
  selectedCategory.value = category;
  vorstandOnly.value = false;
};

console.log(filteredMembers.value);

const currentYear = computed(() => new Date().getFullYear());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("h2", _hoisted_2, " Die Kröntä Guggä hat in der aktuellen Saison " + _toDisplayString(_ctx.members.length) + " Mitglieder ", 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("a", {
        class: _normalizeClass(["hover:cursor-pointer hover:border-b border-orange-p mr-[2rem]", {
        'border-b-2 hover:border-b-2 font-semibold border-orange-p': selectedCategory.value === null && !vorstandOnly.value,
      }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (selectCategory(null)))
      }, "Alle", 2),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.instrumentCategories, (category) => {
        return (_openBlock(), _createElementBlock("a", {
          class: _normalizeClass(["hover:cursor-pointer hover:border-b border-orange-p mr-[2rem]", {
        'border-b-2 hover:border-b-2 font-semibold  border-orange-p':
          selectedCategory.value === category.title && !vorstandOnly.value,
      }]),
          key: category.id,
          onClick: ($event: any) => (selectCategory(category.title))
        }, _toDisplayString(category.title), 11, _hoisted_4))
      }), 128)),
      _createElementVNode("a", {
        class: _normalizeClass(["hover:cursor-pointer hover:border-b border-orange-p", {
        'border-b-2 hover:border-b-2 font-semibold  border-orange-p': vorstandOnly.value,
      }]),
        onClick: toggleVorstandOn
      }, "Vorstand", 2)
    ]),
    (vorstandOnly.value)
      ? (_openBlock(), _createElementBlock("section", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(vorstandMembers.value, (member) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "flex flex-col h-[50rem] shadow-lg rounded-[1.5rem]",
                key: member.id
              }, [
                _createElementVNode("div", {
                  class: "bg-cover bg-center bg-no-repeat h-[60%] w-full shadow-sm rounded-[1.5rem]",
                  style: _normalizeStyle({
            backgroundImage: `url(${member.image.url})`,
            backgroundPosition: member.image.focalPoint
              ? `${member.image.focalPoint.x * 100}% ${
                  member.image.focalPoint.y * 100
                }%`
              : 'center',
          })
                }, null, 4),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("h5", _hoisted_9, _toDisplayString(member.vorname) + " " + _toDisplayString(member.nachname), 1),
                  (member.vorstand)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(member.vorstand), 1))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(member.aemtli, (aemtli) => {
                    return (_openBlock(), _createElementBlock("p", { key: aemtli }, _toDisplayString(aemtli), 1))
                  }), 128)),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("p", null, " Dabei seit " + _toDisplayString(member.since ? parseInt(member.since) - 1 : currentYear.value - 1), 1)
                  ])
                ])
              ]))
            }), 128))
          ])
        ]))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(filteredMembers.value, (category) => {
          return (_openBlock(), _createElementBlock("section", {
            class: "pb-[2.5rem]",
            key: category.instrument
          }, [
            _createElementVNode("h2", _hoisted_12, _toDisplayString(category.instrument), 1),
            _createElementVNode("div", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.members, (member) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "flex flex-col h-[45rem] md:h-[50rem] shadow-lg rounded-[1.5rem] mb-[2rem] md:mb-[1rem]",
                  key: member.id
                }, [
                  _createElementVNode("div", {
                    class: "bg-cover bg-center bg-no-repeat h-[60%] w-full shadow-sm rounded-[1.5rem]",
                    style: _normalizeStyle({
            backgroundImage: `url(${member.image.url})`,
            backgroundPosition: member.image.focalPoint
              ? `${member.image.focalPoint.x * 100}% ${
                  member.image.focalPoint.y * 100
                }%`
              : 'center',
          })
                  }, null, 4),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("h5", _hoisted_15, _toDisplayString(member.vorname) + " " + _toDisplayString(member.nachname), 1),
                    (member.vorstand)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(member.vorstand), 1))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(member.aemtli, (aemtli) => {
                      return (_openBlock(), _createElementBlock("p", { key: aemtli }, _toDisplayString(aemtli), 1))
                    }), 128)),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("p", null, " Dabei seit " + _toDisplayString(member.since ? parseInt(member.since) - 1 : currentYear.value - 1), 1)
                    ])
                  ])
                ]))
              }), 128))
            ])
          ]))
        }), 128))
  ], 64))
}
}

})